(function () {
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-cert-open]');
    if (openBtn) {
      var modal = document.querySelector('[data-cert-modal]');
      if (modal) {
        modal.hidden = false;
        document.body.classList.add('cert-modal-open');
      }
      return;
    }

    var closeEl = e.target.closest('[data-cert-close]');
    if (closeEl) {
      var openModal = closeEl.closest('[data-cert-modal]') || document.querySelector('[data-cert-modal]');
      if (openModal) {
        openModal.hidden = true;
        document.body.classList.remove('cert-modal-open');
      }
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var openModal = document.querySelector('[data-cert-modal]:not([hidden])');
      if (openModal) {
        openModal.hidden = true;
        document.body.classList.remove('cert-modal-open');
      }
    }
  });
})();